function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("rect", {
  id: "Rectangle_89048",
  "data-name": "Rectangle 89048",
  width: 22.615,
  height: 21.28
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_19506",
  "data-name": "Group 19506",
  transform: "translate(-0.002)"
}, React.createElement("g", {
  id: "Group_19486",
  "data-name": "Group 19486",
  transform: "translate(0.001)",
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  id: "Path_24492",
  "data-name": "Path 24492",
  d: "M22.22,6.752a1.794,1.794,0,0,0-.926-.578v.007H18.015L15.2.544a.983.983,0,1,0-1.759.878l2.376,4.759H6.842L9.218,1.422A.983.983,0,1,0,7.459.544L4.645,6.181H1.368A1.718,1.718,0,0,0,0,7.854a1.344,1.344,0,0,0,.027.331L2.234,19.3A2.455,2.455,0,0,0,4.661,21.28H17.947A2.455,2.455,0,0,0,20.374,19.3L22.581,8.184a1.708,1.708,0,0,0-.361-1.433m-13.7,9.213a1.027,1.027,0,1,1-2.055,0V11.676a1.027,1.027,0,1,1,2.055,0Zm3.842,0a1.027,1.027,0,1,1-2.055,0V11.676a1.027,1.027,0,1,1,2.055,0Zm3.842,0a1.027,1.027,0,1,1-2.055,0V11.676a1.027,1.027,0,1,1,2.055,0Z",
  transform: "translate(0 0)"
})));

var SvgBasket = function SvgBasket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 22.615,
    height: 21.28,
    viewBox: "0 0 22.615 21.28",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBasket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Basket.258ef02e.svg";
export { ForwardRef as ReactComponent };